import fetch from 'utils/fetch';

export function changeIpList(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/changeIpList',
        method: 'post',
        data
    });
}

export function batchChangeIp(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/batchChangeIp',
        method: 'post',
        data
    });
}

export function batchChangeIpCheckAccount(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/batchChangeIpCheckAccount',
        method: 'post',
        data
    });
}

export function ipGroupList(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/ipGroupList',
        method: 'post',
        data
    });
}

export function searchChangeIpList(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/searchChangeIpList',
        method: 'post',
        data
    });
}


// WEBPACK FOOTER //
// ./src/api/changeIp.js